import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { examOverview } from '@/mocks/certificateData';

export default function ExamOverview() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('certificate.exam.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('certificate.exam.title') : examOverview.title}
          </h2>
          <p className="text-accent-400 text-[15px] tracking-[0.12em] mb-4 font-label">
            {examOverview.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">
            {lang === 'en' ? t('certificate.exam.lead') : examOverview.lead}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {examOverview.exams.map((exam, idx) => (
            <div
              key={idx}
              className="bg-primary-800/50 p-6 text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-accent-500/15 rounded-full">
                <i className={`${exam.icon} text-accent-400 text-lg`}></i>
              </div>
              <p className="text-[13px] text-accent-400 tracking-[0.12em] mb-1 font-label">
                {exam.courseEn}
              </p>
              <h3 className="font-heading text-[16px] text-foreground-50 tracking-[0.05em] mb-3">
                {lang === 'en' ? t(`certificate.exam.${idx}.content`) : exam.content}
              </h3>
              <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed">
                {lang === 'en' ? t(`certificate.exam.${idx}.desc`) : exam.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
